import React, { useState, useMemo, useEffect } from 'react';
import { Form, Tag } from 'antd';
import { useQuery } from 'react-query';

import DataGrid, { DataGridProps } from 'components/DataGrid/DataGrid';
import DF from 'DisplayFramework';
import RouterLink from 'components/RouterLink/RouterLink';
import { DataGridColDef } from 'components/DataGrid/DataGrid';
import ParListSelect from 'components/ParListSelect/ParListSelect';
import ActivateDisableBrokerButton from './Components/ActivateDisableBroker';
import {
  MgBrokerResponse,
  GetBrokerListByCriteriaParams,
  getBrokerListByCriteria,
} from 'services/parametersService';
import { BrokerForProposalType } from 'components/BrokerInput';
import { isEmpty } from 'lodash';
import { useHistory } from 'react-router';
import ModalControllerNV from 'components/ModalControllerNV';
import ThirdPartyModal from 'pages/ThirdParty/ThirdPartyDetail/ThirdPartyModal';
import MgCompanyList from 'components/MgCompanyList';

export type BrokerSearchProps = Pick<DataGridProps<any>, 'rowSelection'> & {
  isModal?: string;
  initialSearchParams?: Partial<GetBrokerListByCriteriaParams>;
  onSelect?: (item: MgBrokerResponse) => void;
  allowCreate?: boolean;
  isProposalCreate?: boolean;

  setBrokerForProposal?: (BrokerForProposal: BrokerForProposalType) => void;
  hideBrokerModal?: () => void;
};
const ListOfBrokers = ({
  onSelect,
  initialSearchParams,
  ...props
}: BrokerSearchProps) => {
  const [form] = Form.useForm();
  const history = useHistory();
  const initialSearchsParams: GetBrokerListByCriteriaParams = {
    mgid: Number(localStorage.getItem('mgid')) ?? 0,
    brokername: '',
    networkcode: '',
    brokerreference: '',
    brokerstatus: '',
    tprole: '',
  };
  const [searchParams, setSearchParams] =
    useState<GetBrokerListByCriteriaParams>(initialSearchsParams);

  const fieldName = 'brokers';
  const [searchs, setsearchs] = useState(false);
  const { data, refetch, isFetching } = useQuery(
    ['getBrokerListByCriteria', searchParams],
    () => getBrokerListByCriteria(searchParams).then((res) => res.list || []),
    { enabled: searchs }
  );

  useEffect(() => {
    if (data) {
      form.setFieldsValue({ [fieldName]: data });
    }
  }, [form, data]);

  const columns = useMemo<DataGridColDef<MgBrokerResponse>[]>(
    () => [
      {
        dataIndex: 'brokerreference',
        filtrable: true,
        render: (value, record) => (
          <RouterLink
            onClick={() => {
              onSelect
                ? onSelect(record)
                : history.push(
                    `/configuration/management-company/${record.mgid}/broker/${record.associd}`
                  );
            }}
          >
            {record.brokerreference}
          </RouterLink>
        ),
      },
      {
        dataIndex: 'brokername',
        filtrable: true,
        render: (value, record, index) => {
          return (
            <ModalControllerNV
              modal={({ setVisible, visible }) => (
                <ThirdPartyModal
                  tpId={record.tpidbroker}
                  visible={visible}
                  onCancel={() => setVisible(false)}
                  onSuccess={() => setVisible(false)}
                  title={record.brokername}
                  iscreate={false}
                />
              )}
              content={({ setVisible, visible }) => (
                <a
                  onClick={() => {
                    setVisible(true);
                  }}
                >
                  {value}
                </a>
              )}
            />
          );
        },
      },

      {
        dataIndex: 'mgid',
        filtrable: true,
        filterComponent: <MgCompanyList value={localStorage.getItem('mgid')}/>,
        render: (value, record) => record.mgname,
        // <RouterLink to={`/configuration/management-company/mg/${value}`}>
        //   {record.mgname}
        // </RouterLink>
        width: 200,
      },
      {
        dataIndex: 'tprole',
        filtrable: true,
        filterComponent: (
          <ParListSelect
            parcode="BRROLE"
            style={{ width: '100%' }}
            allowClear
          />
        ),
        render: (_, record) => record.tprolelabel,
      },

      {
        dataIndex: 'networkcode',
        filtrable: true,
        filterComponent: (
          <ParListSelect
            parcode="NETWORK"
            disabled={!isEmpty(initialSearchParams?.networkcode)}
            allowClear
          />
        ),
        render: (_, record) => record.networklabel,
      },

      { dataIndex: 'startdate' },
      { dataIndex: 'enddate' },

      {
        dataIndex: 'brokerstatus',
        filtrable: true,
        filterComponent: (
          <ParListSelect
            parcode="BROSTATUS"
            style={{ width: '100%' }}
            allowClear
          />
        ),
        render: (_, record) => (
          <Tag
            color={
               record.brokerstatus === 'ACTIVE'
                ? 'success'
                : record.brokerstatus === 'DISABLED'
                ? 'error'
                : 'default'
            }
          >
            {record.statuslabel}
          </Tag>
        ),
      },
      {
        key: 'action',
        render: (_, record) => (
          <ActivateDisableBrokerButton
            mgid={record.mgid}
            associd={record.associd}
            statusToUpdate={record.brokerstatus}
            refetch={refetch}
          />
        ),
        width: 150,
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [onSelect, refetch]
  );

  return (
    <DF.Provider pagcode="brokerslist">
      <Form form={form}>
        <Form.Item noStyle shouldUpdate>
          {({ getFieldValue }) => {
            const brokers: MgBrokerResponse[] = getFieldValue(fieldName);
            return (
              <DataGrid
                rowKey="associd"
                titleComcode="listOfBrokers"
                isLoading={isFetching}
                dataSource={brokers}
                columns={columns}
                onSearch={(values) => {
                  setSearchParams(values);
                  setsearchs(true);
                }}
                initialSearchValues={initialSearchsParams}
              />
            );
          }}
        </Form.Item>
      </Form>
    </DF.Provider>
  );
};

export default ListOfBrokers;
